import React, { useState } from 'react';
import TextInput from '../TextInput';
import { DropdownMenu } from '../DropdownMenu';
import DateInput from '../DateInput';
import { Certification, CertificationType } from '../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseModels';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import CertificationRendererManager from '../../../store/Managers/CertificationRendererManager';

interface CertificationProps {
    response: Certification;
    onResponseChange: (value: Certification) => void;
    localizer: IStringLocalizer;
}

const CertificationInput: React.FC<CertificationProps> = ({ response, onResponseChange, localizer }) => {
    const [nameValue, setNameValue] = useState(response.name || '');
    const [typeValue, setTypeValue] = useState(response.type || CertificationType.Other);
    const [idValue, setIdValue] = useState(response.certificationExternalId || '');
    const [levelValue, setLevelValue] = useState(response.metadata?.level || '');
    const [dateValue, setDateValue] = useState(response.expirationDate || '');

    const handleNameValueChange = (newValue: string) => {
        setNameValue(newValue);

        if (onResponseChange) {
            onResponseChange({
                name: newValue,
                certificationExternalId: idValue,
                expirationDate: dateValue,
                metadata: {
                    level: levelValue
                },
                type: typeValue
            })
        }
    };

    const handleTypeValueChange = (newValue: string) => {
        var certification = newValue as CertificationType;
        setTypeValue(certification);

        if (onResponseChange) {
            onResponseChange({
                name: nameValue,
                certificationExternalId: idValue,
                expirationDate: dateValue,
                metadata: {
                    level: levelValue
                },
                type: certification
            })
        }
    };

    const handleIdValueChange = (newValue: string) => {
        setIdValue(newValue);

        if (onResponseChange) {
            onResponseChange({
                name: nameValue,
                certificationExternalId: newValue,
                expirationDate: dateValue,
                metadata: {
                    level: levelValue
                },
                type: typeValue
            })
        }
    };

    const handleLevelValueChange = (newValue: string) => {
        setLevelValue(newValue);

        if (onResponseChange) {
            onResponseChange({
                name: nameValue,
                certificationExternalId: idValue,
                expirationDate: dateValue,
                metadata: {
                    level: newValue
                },
                type: typeValue
            });
        }
    };

    const handleDateValueChange = (newValue: string) => {
        setDateValue(newValue);

        if (onResponseChange) {
            onResponseChange({
                name: nameValue,
                certificationExternalId: idValue,
                expirationDate: newValue,
                metadata: {
                    level: levelValue
                },
                type: typeValue
            })
        }
    };

    return (
        <div className="certification-field-container">
            <div className="row m-0 m-b-20">
                <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2 p-l-0">
                    <label>{localizer.localizeString("Name")}</label>
                </div>
                <div className="col-xs-12 col-sm-6 col-lg-10 p-r-0">
                    <TextInput value={nameValue} onValueChange={handleNameValueChange}></TextInput>
                </div>
            </div>

            <div className="row m-0 m-b-20">
                <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2 p-l-0">
                    <label>{localizer.localizeString("Type")}</label>
                </div>
                <div className="col-xs-12 col-sm-6 col-lg-10 p-r-0">
                    <DropdownMenu options={Object.values(CertificationType)}
                        onOptionSelected={handleTypeValueChange}
                        getFriendlyNameForOptions={o => CertificationRendererManager.getFriendlyNameForCertificationType(o as CertificationType, localizer)}
                        getUniqueValueForOption={o => o}
                        preselectedOption={typeValue}>
                    </DropdownMenu>
                </div>
            </div>

            <div className="row m-0 m-b-20">
                <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2 p-l-0">
                    <label>{localizer.localizeString("Id")}</label>
                </div>
                <div className="col-xs-12 col-sm-6 col-lg-10 p-r-0">
                    <TextInput value={idValue} onValueChange={handleIdValueChange}></TextInput>
                </div>
            </div>

            <div className="row m-0 m-b-20">
                <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2 p-l-0">
                    <label>{localizer.localizeString("Level")}</label>
                </div>
                <div className="col-xs-12 col-sm-6 col-lg-10 p-r-0">
                    <TextInput value={levelValue} onValueChange={handleLevelValueChange}></TextInput>
                </div>
            </div>

            <div className="row m-0 m-b-20">
                <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2 p-l-0">
                    <label>{localizer.localizeString("Expiration Date")}</label>
                </div>
                <div className="col-xs-12 col-sm-6 col-lg-10 p-r-0">
                    <DateInput value={dateValue} onValueChange={handleDateValueChange}></DateInput>
                </div>
            </div>
        </div>
    );

};

export default CertificationInput;